import { useQuery } from "@tanstack/react-query";

import { readProjectsTimer } from "../../../services/projects";

type TResponseReadProjectTimer = {
    projects: {
        color: string;
        description: string;
        id_e: string;
        name: string;
        profiles: {
            abbreviation: string;
            id_e: string;
            name: string;
        }[];
    }[];
};

export function useReadProjectTimer({
    params,
    start,
    onFinish,
}: {
    start?: boolean;
    params: {
        users: boolean;
    };
    onFinish?: (value: any) => void;
}) {
    return useQuery<
        TResponseReadProjectTimer,
        unknown,
        TResponseReadProjectTimer
    >({
        enabled: !!start,
        queryKey: [`readCategory`],
        queryFn: () => readProjectsTimer({ ...params }),
        refetchOnMount: "always",
        refetchOnWindowFocus: false,
        refetchIntervalInBackground: false,
        onSuccess: onFinish,
    });
}
